import { Link } from './link';
import { Text } from './text';

export const text = {
  Text,
  Link,
};
